import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { plansAPI, authAPI } from '../../services/api';
import toast from 'react-hot-toast';

const inp = { width:'100%', padding:'10px 14px', border:'1.5px solid #E5E7EB', borderRadius:8, fontSize:'1rem', outline:'none', boxSizing:'border-box' };
const lbl = { display:'block', fontWeight:600, fontSize:'.85rem', marginBottom:6, color:'#374151' };
const STEP_LABELS = ['Plano', 'Empresa', 'Acesso', 'Pagamento'];

export default function Register() {
  const [step, setStep]   = useState(0);
  const [plans, setPlans] = useState([]);
  const [form, setForm]   = useState({ plan_id:'', company:'', name:'', phone:'', email:'', password:'', password_confirm:'' });
  const [loading, setLoading] = useState(false);
  const [pixData, setPixData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    plansAPI.list().then(r => setPlans(r.data.data || [])).catch(() => {});
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const selectedPlan = plans.find(p => String(p.id) === String(form.plan_id));
  const fmt = v => `R$ ${parseFloat(v||0).toFixed(2).replace('.',',')}`;

  const next = (e) => {
    e && e.preventDefault();
    if (step === 0 && !form.plan_id) { toast.error('Selecione um plano.'); return; }
    if (step === 2 && form.password !== form.password_confirm) { toast.error('Senhas não conferem.'); return; }
    if (step === 2) { submit(); return; }
    setStep(s => s + 1);
  };

  const submit = async () => {
    setLoading(true);
    try {
      const { password_confirm, ...payload } = form;
      const r = await authAPI.register(payload);
      const data = r.data.data;
      if (data?.pix_qr_code) { setPixData(data); setStep(3); }
      else { toast.success('Conta criada! Faça login.'); navigate('/login'); }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erro ao criar conta. Tente novamente.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#F8FAFC', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:'#fff', borderRadius:20, padding:'36px 32px', width:'100%', maxWidth:520, boxShadow:'0 4px 24px rgba(0,0,0,.08)' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:'2rem', marginBottom:4 }}>🚗</div>
          <h1 style={{ fontSize:'1.5rem', fontWeight:900, color:'#0F172A' }}>AutoFlow</h1>
          <p style={{ color:'#6B7280', fontSize:'.9rem' }}>Crie sua conta grátis</p>
        </div>

        <div style={{ display:'flex', gap:6, marginBottom:28 }}>
          {STEP_LABELS.map((l, i) => (
            <div key={l} style={{ flex:1, textAlign:'center' }}>
              <div style={{ height:4, borderRadius:4, background: i <= step ? '#2563EB' : '#E5E7EB', marginBottom:4 }} />
              <span style={{ fontSize:'.7rem', color: i === step ? '#2563EB' : '#9CA3AF', fontWeight: i === step ? 700 : 400 }}>{l}</span>
            </div>
          ))}
        </div>

        {step === 0 && (
          <div>
            <h2 style={{ fontWeight:700, marginBottom:16, color:'#0F172A' }}>Escolha seu plano</h2>
            {plans.length === 0 && <p style={{ color:'#9CA3AF', textAlign:'center' }}>Carregando planos...</p>}
            <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:24 }}>
              {plans.map(p => (
                <label key={p.id} style={{ border:`2px solid ${String(form.plan_id)===String(p.id)?'#2563EB':'#E5E7EB'}`, borderRadius:12, padding:'16px 20px', cursor:'pointer', background: String(form.plan_id)===String(p.id)?'#EFF6FF':'#fff' }}>
                  <input type="radio" name="plan" value={p.id} checked={String(form.plan_id)===String(p.id)} onChange={()=>set('plan_id',String(p.id))} style={{ display:'none' }} />
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div>
                      <div style={{ fontWeight:700, color:'#0F172A' }}>{p.name}</div>
                      <div style={{ fontSize:'.8rem', color:'#6B7280', marginTop:2 }}>{p.description}</div>
                      {p.trial_days > 0 && <div style={{ fontSize:'.75rem', color:'#059669', fontWeight:600, marginTop:4 }}>✓ {p.trial_days} dias grátis</div>}
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontWeight:800, color:'#2563EB', fontSize:'1.1rem', whiteSpace:'nowrap' }}>{fmt(p.price_monthly)}<span style={{ fontSize:'.7rem', fontWeight:400, color:'#9CA3AF' }}>/mês</span></div>
                      {p.price_yearly > 0 && <div style={{ fontSize:'.7rem', color:'#6B7280' }}>{fmt(p.price_yearly)}/ano</div>}
                    </div>
                  </div>
                </label>
              ))}
            </div>
            <button onClick={next} style={{ width:'100%', padding:12, background:'#2563EB', color:'#fff', border:'none', borderRadius:10, fontWeight:700, fontSize:'1rem', cursor:'pointer' }}>Continuar →</button>
          </div>
        )}

        {step === 1 && (
          <form onSubmit={next}>
            <h2 style={{ fontWeight:700, marginBottom:16, color:'#0F172A' }}>Dados da empresa</h2>
            {[
              ['company','Nome da empresa *','text',true],
              ['name','Seu nome (responsável) *','text',true],
              ['phone','Telefone (com DDD) *','tel',true],
            ].map(([k,l,t,r]) => (
              <div key={k} style={{ marginBottom:14 }}>
                <label style={lbl}>{l}</label>
                <input type={t} value={form[k]} onChange={e=>set(k,e.target.value)} required={r} style={inp} placeholder={k==='phone'?'(11) 99999-9999':''} />
              </div>
            ))}
            <div style={{ display:'flex', gap:10, marginTop:8 }}>
              <button type="button" onClick={()=>setStep(0)} style={{ flex:1, padding:12, border:'1.5px solid #E5E7EB', borderRadius:10, background:'#fff', cursor:'pointer' }}>← Voltar</button>
              <button type="submit" style={{ flex:2, padding:12, background:'#2563EB', color:'#fff', border:'none', borderRadius:10, fontWeight:700, cursor:'pointer' }}>Continuar →</button>
            </div>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={next}>
            <h2 style={{ fontWeight:700, marginBottom:16, color:'#0F172A' }}>Crie seu acesso</h2>
            {[
              ['email','E-mail *','email',true],
              ['password','Senha (mín. 8 caracteres) *','password',true],
              ['password_confirm','Confirmar senha *','password',true],
            ].map(([k,l,t,r]) => (
              <div key={k} style={{ marginBottom:14 }}>
                <label style={lbl}>{l}</label>
                <input type={t} value={form[k]} onChange={e=>set(k,e.target.value)} required={r} minLength={k==='password'?8:undefined} style={inp} />
              </div>
            ))}
            <div style={{ background:'#F0FDF4', borderRadius:10, padding:'10px 14px', marginBottom:16, fontSize:'.85rem', color:'#166534' }}>
              Plano: <strong>{selectedPlan?.name}</strong> — {fmt(selectedPlan?.price_monthly)}/mês
              {selectedPlan?.trial_days > 0 && <span style={{ marginLeft:8, color:'#059669' }}>({selectedPlan.trial_days} dias grátis)</span>}
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button type="button" onClick={()=>setStep(1)} style={{ flex:1, padding:12, border:'1.5px solid #E5E7EB', borderRadius:10, background:'#fff', cursor:'pointer' }}>← Voltar</button>
              <button type="submit" disabled={loading} style={{ flex:2, padding:12, background:'#2563EB', color:'#fff', border:'none', borderRadius:10, fontWeight:700, cursor:'pointer', opacity:loading?0.7:1 }}>
                {loading ? 'Criando conta...' : 'Criar conta'}
              </button>
            </div>
          </form>
        )}

        {step === 3 && pixData && (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:8 }}>✅</div>
            <h2 style={{ fontWeight:700, color:'#0F172A', marginBottom:8 }}>Conta criada!</h2>
            <p style={{ color:'#6B7280', fontSize:'.9rem', marginBottom:20 }}>Escaneie o QR Code PIX para ativar sua conta:</p>
            {pixData.pix_qr_code && <img src={`data:image/png;base64,${pixData.pix_qr_code}`} alt="QR Code PIX" style={{ width:200, height:200, borderRadius:12, border:'1px solid #E5E7EB', marginBottom:16 }} />}
            {pixData.pix_copia_cola && (
              <div>
                <div style={{ background:'#F8FAFC', borderRadius:8, padding:'10px 14px', fontSize:'.7rem', wordBreak:'break-all', color:'#374151', border:'1px solid #E5E7EB', marginBottom:12 }}>{pixData.pix_copia_cola}</div>
                <button onClick={()=>{ navigator.clipboard.writeText(pixData.pix_copia_cola); toast.success('Copiado!'); }} style={{ padding:'8px 20px', background:'#059669', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', marginBottom:16 }}>Copiar código PIX</button>
              </div>
            )}
            <p style={{ fontSize:'.8rem', color:'#9CA3AF', marginBottom:16 }}>Após o pagamento, sua conta será ativada automaticamente.</p>
            <button onClick={()=>navigate('/login')} style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Ir para Login</button>
          </div>
        )}

        {step < 3 && (
          <p style={{ textAlign:'center', marginTop:20, fontSize:'.85rem', color:'#6B7280' }}>
            Já tem conta? <Link to="/login" style={{ color:'#2563EB', fontWeight:600, textDecoration:'none' }}>Entrar</Link>
          </p>
        )}
      </div>
    </div>
  );
}
